/**
 * True only for the /admin section itself: `/admin` or `/admin/...` (a whole path segment).
 * A string prefix match would also catch public store slugs such as /adminmart or /adminvps and send their pages to the login.
 */
export function isAdminPath(pathname: string | null | undefined): boolean {
    return pathname === "/admin" || (typeof pathname === "string" && pathname.startsWith("/admin/"));
}
